import React, { Component } from 'react';
import Hero from './content/Hero';
import Feature from './content/Feature';
import LastCall from './content/LastCall';
import Footer from './content/Footer';
import WebfineryNavbar from './WebfineryNavbar';
import { Grid, Row, Col, Button, Image } from 'react-bootstrap';
import mixpanel from "mixpanel-browser";
import { LinkContainer } from "react-router-bootstrap";
import ContactModal from './ContactModal';
import { browserHistory } from "react-router";

import './content/content.css';

import Newsletter from "./Newsletter";

class LandingPage extends Component {

	constructor() {
		super();
		this.mixpanel = mixpanel;
		this.landingHeroContent = this.landingHeroContent.bind(this);		
		this.state = { fa: "fa-envelope-open-o", contactModalVisible: false, contactModalTopic: "", contactModalMessage: "", contactModalCue:"", contactModalPush: "" };
		this.handleShowContactUs = this.handleShowContactUs.bind(this);
		this.handleHideContactUs = this.handleHideContactUs.bind(this);
		this.handleBacklinksClick = this.handleBacklinksClick.bind(this);
		this.handleAlertsClick = this.handleAlertsClick.bind(this);
	}

	componentDidMount () {
	  window.scrollTo(0, 0)
	}

	landingHeroContent() {
		return (
			<div>
				<h1>Web Data Intelligence</h1>
				<h2>Gain marketwide insight, generate leads, stay ahead of your competition</h2>
				<h3>Solutions for marketers, sales teams, web researchers, SEO experts, agencies and SaaS companies</h3>
				<div>
					<Button bsStyle="success" bsSize="lg" onClick={this.handleShowContactUs}>Contact us</Button>
					<a href="#main" className="btn btn-default btn-lg">Learn more</a>
				</div>
			</div>
		)
	}

	handleShowContactUs() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery", 
			contactModalCue: "Contact Us",
			contactModalPush: "",
			messageInputCollapsed: false
		});
	}

	handleHideContactUs() {
		this.setState({contactModalVisible: false});	
	}

	handleBacklinksClick() {
		this.setState({contactModalVisible: true, fa: "fa-chain-broken", contactModalTopic: "Webfinery Backlinks Early Access", 
			contactModalCue: "Be the first to get access as soon as available",
			contactModalPush: "Sign up now to get 20% discount for all the pricing plans forever"			
		});
	}

	handleAlertsClick() {
		this.setState({contactModalVisible: true, fa: "fa-eye", contactModalTopic: "Webfinery Alerts Early Access", 
			contactModalCue: "Be the first to get access as soon as available",
			contactModalPush: "Sign up now to get 20% discount for all the pricing plans forever",
			messageInputCollapsed: true
		});
	}

  	render() {
	    return (
    		<div>      			
    			<WebfineryNavbar/>
    			<Hero className="hero-landing">
    				{this.landingHeroContent()}
    			</Hero>

    			<div id="main">

	    			<Feature shade={true} fluid={true}>
		    			<Grid>
		    				<Row>
								<Col md={6}>
									<div className="feature-box">										
										<Image className="FeatureImage clickable" src={process.env.PUBLIC_URL + '/webfinery-search.png'} responsive onClick={() => browserHistory.push('/search')}/>
									</div>
								</Col>	    				
								<Col md={6} style={{textAlign: 'left'}}>
									<div className="feature-box">
										<h3>Search</h3>					
										<h4>Source code of the web</h4>
										<h5>
											Discover websites using specific web technologies, JavaScript libraries, themes, server versions, 
											and much more. Research, generate leads, analyze.
										</h5>
										<LinkContainer to="/search">
					    					<Button bsSize="large" bsStyle="success">Get started <sup>Free</sup></Button>
					    				</LinkContainer>
					    			</div>
								</Col>
							</Row>
						</Grid>
					</Feature>

	    			<Feature shade={false} fluid={true}>
		    			<Grid>
		    				<Row>
								<Col md={6}>
									<div className="feature-box">
										<a href="https://www.visitrank.com" target="_blank">
											<Image className="FeatureImage" src={process.env.PUBLIC_URL + '/webfinery-visitrank.png'} responsive />
										</a>
									</div>
								</Col>	    				
								<Col md={6} style={{textAlign: 'left'}}>
									<div className="feature-box">
										<h3>Rank</h3>
					    				<h4>Rank any website fast</h4>
										<h5>
											Every website has a measurable impact on the rest of the web. Find out how popular and influential is every website you visit with our free Chrome Extension.
										</h5>
										<a href="https://www.visitrank.com" target="_blank">
	                                      	<Button bsStyle="success" bsSize="lg">Visit Rank <sup>Free</sup></Button>
		                             	</a>
					    			</div>
								</Col>
							</Row>
						</Grid>
					</Feature>

					<Feature shade={true}>
						<Grid>
							<Row>
								<Col md={12} className="text-center">
										<h3>Alerts</h3>
										<div className="benefit">
											<h5><i className="fa fa-eye fa-3x" aria-hidden="true"></i></h5>
						    				<h4>uptime and content monitoring</h4>
						    				<h5>
						    					Monitor any website and get notified when it gets updated.<br />
						    					Be the first to know about price changes, news, competitor's updates, and much more.<br />
						    					Monitor your own websites and immediately get notified when they fail.<br />
						    					Custom deep inspection of HTTP responses for advanced users.<br />
						    				</h5>
					    					<div>
					    						<Button bsStyle="success" onClick={this.handleAlertsClick}>Alerts <sup>Early access</sup></Button>						    						
					    					</div>
						    				<br /><small><strong>Join now and get 20% off after public release</strong></small>
						    			</div>
								</Col>
							</Row>
						</Grid>
					</Feature>


	    			<Feature shade={true}>
		    			<Grid>
		    				<Row>
								<Col md={12} className="text-center">
										<h3>Backlinks</h3>
										<div className="benefit">
											<h5><i className="fa fa-chain-broken fa-3x" aria-hidden="true"></i></h5>					    				
						    				<h4>Backlink research and monitoring</h4>
						    				<h5>
						    					Research your competition.<br />
						    					Never loose a backlink again.<br />
						    					Act when your competitors gain new backlinks.<br />
						    					Save time and automate your efforts.<br />
						    				</h5>						    				
					    					<div>
					    						<Button bsStyle="success" onClick={this.handleBacklinksClick}>Backlinks <sup>Early access</sup></Button>
					    					</div>
						    				<br /><small><strong>Join now and get 20% off after public release</strong></small>
						    			</div>
								</Col>
							</Row>
						</Grid>
					</Feature>

	    			<Feature shade={true} fluid={true}>
		    			<Grid>
		    				<Row>
								<Col md={6}>
									<div>
					    				<h3>Cloud</h3>
					    				<h4>Crawler and Web APIS</h4>
					    				<h5>Fuel your apps with web data. Extract, transform, enrich, productize.</h5>
					    				<LinkContainer to="/cloud">
					    					<Button>Learn more</Button>
					    				</LinkContainer>								
					    			</div>
								</Col>
								<Col md={6}>
									<div>
					    				<h3>Consulting</h3>
					    				<h4>Your Custom Solution</h4>
					    				<h5>End-to-end web data solution built by us according to your requirements.</h5>
					    				<LinkContainer to="/consulting">
					    					<Button>Learn more</Button>
					    				</LinkContainer>
									</div>
								</Col>
							</Row>
						</Grid>
					</Feature>


	    			<LastCall>
	    				<Newsletter/>
	    			</LastCall>

	    		</div>

    			<Footer/>

    			<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
    				contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
    				visible={this.state.contactModalVisible} handleHide={this.handleHideContactUs} 
    				submittedLabel={this.state.contactModalSubmittedLabel} 
    				messageInputCollapsed={this.state.messageInputCollapsed} />
    		</div>
		)
	}
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/LandingPage.js